<div class="employee-card-list">
  <mat-grid-list [cols]="colNumber" rowHeight='290px' (window:resize)="onResize($event)">
    <mat-grid-tile *ngFor="let employee of employees; let i = index">
      <app-employee-card class="employee-card-container" [employee]="employee"></app-employee-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
